import React from "react";
import "./Paragraph.scss";

const Paragraph = React.forwardRef(
  ({ className = "", size = "medium", weight = "regular", children, ...props }, ref) => {
    const sizeClass = `text-${size}`;
    const weightClass = `text-${weight}`;

    return (
      <p
        ref={ref}
        data-component="paragraph"
        {...props}
        className={`${sizeClass} ${weightClass} ${className}`}
      >
        {children}
      </p>
    );
  }
);

export default Paragraph;
